<template>
  <svg width="100"
       height="100"
       viewBox="0 0 100 100"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8653_97580)">
      <rect x="6.25"
            y="6.25"
            width="87.5"
            height="87.5"
            rx="11.25"
            fill="url(#paint0_linear_8653_97580)"
      />
      <rect x="6.25"
            y="6.25"
            width="87.5"
            height="87.5"
            rx="11.25"
            fill="url(#paint1_radial_8653_97580)"
      />
      <rect x="6.25"
            y="6.25"
            width="87.5"
            height="87.5"
            rx="11.25"
            fill="url(#paint2_radial_8653_97580)"
      />
      <rect x="6.25"
            y="6.25"
            width="87.5"
            height="87.5"
            rx="11.25"
            fill="url(#paint3_linear_8653_97580)"
      />
      <rect x="6.25"
            y="6.25"
            width="87.5"
            height="87.5"
            rx="11.25"
            fill="url(#paint4_linear_8653_97580)"
      />
      <rect x="6.25"
            y="6.25"
            width="87.5"
            height="87.5"
            rx="11.25"
            fill="url(#paint5_linear_8653_97580)"
      />
      <rect x="6.25"
            y="6.25"
            width="87.5"
            height="87.5"
            rx="11.25"
            fill="url(#paint6_linear_8653_97580)"
      />
      <path d="M42.1122 72.6562C40.9148 72.6562 39.7174 72.2081 38.8027 71.3099L20.8514 53.6806C19.0241 51.8861 19.0241 48.975 20.8514 47.1805C22.6787 45.3859 25.643 45.3859 27.4703 47.1805L41.8932 61.3446C42.0148 61.464 42.2096 61.464 42.3311 61.3446L73.9916 30.2521C75.8189 28.4576 78.7832 28.4576 80.6105 30.2521C82.4378 32.0467 82.4378 34.9578 80.6105 36.7523L45.4216 71.3099C44.5089 72.2081 43.3096 72.6562 42.1122 72.6562Z"
            fill="#FCF2FF"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_8653_97580"
                      x1="50"
                      y1="6.25"
                      x2="50"
                      y2="93.75"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#59D88F" />
        <stop offset="1"
              stop-color="#55CE89"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_8653_97580"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(89.0625 10.9375) rotate(135) scale(11.0485 12.9044)"
      >
        <stop stop-color="#6FF4A4"
              stop-opacity="0.6"
        />
        <stop offset="1"
              stop-color="#6FF4A4"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_8653_97580"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(9.375 90.625) rotate(-40.6013) scale(14.4055 16.8253)"
      >
        <stop stop-color="#388964"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#388964"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_8653_97580"
                      x1="93.75"
                      y1="50"
                      x2="79.6875"
                      y2="50"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6FF4A4"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#6FF4A4"
              stop-opacity="0.3"
        />
        <stop offset="1"
              stop-color="#6FF4A4"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_8653_97580"
                      x1="50"
                      y1="6.25"
                      x2="50"
                      y2="18.75"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6FF4A4"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#6FF4A4"
              stop-opacity="0.4"
        />
        <stop offset="1"
              stop-color="#6FF4A4"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_8653_97580"
                      x1="50"
                      y1="6.25"
                      x2="50"
                      y2="93.75"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#388964"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#388964"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#388964"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#388964"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#388964"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_8653_97580"
                      x1="93.4413"
                      y1="49.2152"
                      x2="7.11848"
                      y2="49.2152"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#388964"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#388964"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#388964"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#388964"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#388964"
        />
      </linearGradient>
      <clipPath id="clip0_8653_97580">
        <rect width="100"
              height="100"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
